/**
 * Created by eskilkeskikangas on 27/06/16.
 */
( function( $ ) {

	 console.log('track');

	$( document ).ready( function() {

		$('body').on('click', '.social-media', function(){

			var label = '';

			if( $(this).find('.instagram').length > 0 ) {
				label = 'instagram';
			}
			if( $(this).find('.facebook').length > 0 ) {
				label = 'facebook';
			}

			if( label !== '' ) {

				__gaTracker('send', {
					hitType: 'event',
					eventCategory: 'Social Follow',
					eventAction: 'Click on ' + label + '-follow-link',
					eventLabel: label + '-banner'
				});

			}

		});

		$('body').on('submit', '.newsletter-signup-form form', function(){

			__gaTracker('send', {
				hitType: 'event',
				eventCategory: 'Newsletter',
				eventAction: 'Subscribe to newsletter',
				eventLabel: 'pop up - newsletter signup'
			});

		});

		$('body').on('submit', '.newsletter form', function(){

			__gaTracker('send', {
				hitType: 'event',
				eventCategory: 'Newsletter',
				eventAction: 'Subscribe to newsletter',
				eventLabel: 'footer - newsletter signup'
			});

		});

		$('body').on('click', '.fsi-group', function(){

			var label = '';

			if( $(this).hasClass('instagram') ) {
				label = 'instagram';
			}
			if( $(this).hasClass('facebook') ) {
				label = 'facebook';
			}

			if( label !== '' ) {

				__gaTracker('send', {
					hitType: 'event',
					eventCategory: 'Social Follow',
					eventAction: 'Click on ' + label + '-follow-link',
					eventLabel: label + '-icon-footer'
				});

			}

		});

	});

})( jQuery );
